import { ReactNode } from 'react';
import { Tooltip } from 'components/common';

interface Props {
  children: ReactNode;
  reasonTexts: string[];
}

const RenderList = ({ reasons }: { reasons: string[] }) => (
  <ul style={{ margin: '5px 0', paddingLeft: 15, listStyleType: 'decimal' }}>
    {reasons.map((text, index) => (
      <li key={index} style={{ marginBottom: 5 }}>
        {text}
      </li>
    ))}
  </ul>
);

const RenderContent = ({ reason }: { reason: string }) => <div>{reason}</div>;

const MandatoryReasonsTooltip = ({ children, reasonTexts }: Props) => {
  return (
    <Tooltip
      childrenWrapInDiv={false}
      content={
        reasonTexts.length > 1 ? (
          <RenderList reasons={reasonTexts} />
        ) : reasonTexts.length ? (
          <RenderContent reason={reasonTexts[0]} />
        ) : null
      }
    >
      {children}
    </Tooltip>
  );
};

export default MandatoryReasonsTooltip;
